import React from 'react';
import { WTitle } from '../../components/Widget';
import VideoTranscript from '../../components/VideoTranscript/index';
import Person from '../../../../../../assets/cybersecurity2026/topic1230pm/section0-img1.png';
import Light from '../../../../../../assets/cybersecurity2026/topic1230pm/section0-img2.png';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
interface ISection0Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '1';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  const { updateParagraphState } = useStore();

  React.useEffect(() => {
    updateParagraphState(p_course, p_topic, ID, 'completed', []);
  }, []);
  React.useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#video1230');
      if (elem?.requestFullscreen) {
        try {
          elem.requestFullscreen();
        } catch (error) {
          console.log(error);
        }
        document
          ?.querySelector('#video1230')
          ?.removeEventListener('play', onPlay);
      }
    };
    document?.querySelector('#video1230')?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#video1230')
      ?.addEventListener('play', onPlay, { passive: true });
    return () =>
      document
        ?.querySelector('#video1230')
        ?.removeEventListener('play', onPlay);
  }, []);

  return (
    <div className="course-landing">
      <div className="course-landing-content">
        <WTitle title={paragraphsSettings.header} />
        <div className="description">{paragraphsSettings.description}</div>
        <div className="course-landing-text">
          <img className="person" src={Person} alt="" />
          <div className="course-box">
            <div className="video-container">
              <video
                id="video1230"
                width="100%"
                controls
                autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
              >
                <source
                  src={paragraphsSettings?.landingVideo?.src}
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video>
              <VideoTranscript transcripts={paragraphsSettings.transcripts} />
            </div>
            <img className="light" src={Light} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section0;
